module.exports = __webpack_public_path__ + "assets/img/1.01248d4d.jpg";